import { Nilable } from "@shared/utils";
import { PaginadoEntidadesState } from "./PaginadoEntidadesState";
import { PaginadoDTO } from "@DTOS";

export class PaginadoEntidadesQueryState<DTO> extends PaginadoEntidadesState<DTO> {
    private terminoBuscado: Nilable<string>;

    /**
     * Carga del paginado dependiendo del termino
     *
     * @param termino Termino a buscar
     * @param paginado Paginado de las entidades
     */
    public cargarPaginadoTermino(termino: string, paginado: PaginadoDTO<DTO>) {
        if (this.verificarTerminoEsParte(termino)) {
            this.reiniciarEntidades();
        }
        super.cargarPaginado(paginado);
    }

    /**
     * Devuelve el ultimo termino buscado
     */
    public obtenerTermino(): Nilable<string> {
        return this.terminoBuscado;
    }

    protected verificarTerminoEsParte(termino: string): boolean {
        if (this.terminoBuscado == null) {
            return false;
        }
        return termino.length < this.terminoBuscado.length ?
            this.terminoBuscado.includes(termino) : termino.includes(this.terminoBuscado);
    }
}
